import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import useMergeState from './useMergeState';
export default function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
    _useMergeState2 = _slicedToArray(_useMergeState, 2),
    state = _useMergeState2[0],
    setState = _useMergeState2[1];
  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}